import React from 'react';

interface IRozpracovaneZadosti {}

const RozpracovaneZadosti: React.FC<IRozpracovaneZadosti> = () => {
    return <></>;
};

export default RozpracovaneZadosti;
